module.exports = __webpack_public_path__ + "a8a06922f0cd35fbb53e7664ac9bbe14.ttf";